import { render, staticRenderFns } from "./projects_by_results.vue?vue&type=template&id=43b2ddda&"
import script from "./projects_by_results.vue?vue&type=script&lang=js&"
export * from "./projects_by_results.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43b2ddda')) {
      api.createRecord('43b2ddda', component.options)
    } else {
      api.reload('43b2ddda', component.options)
    }
    module.hot.accept("./projects_by_results.vue?vue&type=template&id=43b2ddda&", function () {
      api.rerender('43b2ddda', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components-globalwork/metrics/projects_by_results.vue"
export default component.exports